<template>
    <el-dialog
    class="box-card existing_leads existing-leads-modal"
    v-model="open.error"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :show-close="false"
    center
    :width="screen.width > 768 ? '40%' : '90%'"
  >
    <template #header>
      <div class="card-header">
        <span class="text-center" style="overflow-wrap: break-word">{{ $t("dob_error_title") }}</span>
      </div>
    </template>
    <p class="system_err_msg"> {{ open.error_message }} </p>
    <el-divider></el-divider>
    <el-button type="primary" size="large" @click="refresh">Update Details</el-button>
  </el-dialog>
</template>

<script setup>
import { store } from "@/store";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { screen } from "@/store/stateless";

const open = computed(() => {
    return store.state.review.hasDobError
})

const router = useRouter()
function refresh() {
  router.push({name:'TravellerDetails'})
  open.value.error = false
}
</script>

<style>
.system_err_msg{
display: block;
word-break: break-word;
}
</style>
